// @flow
import React from 'react';
import styles from './SubscribeForm.module.scss';

const SubscribeForm = ({ 
  signupSource, 
  isML, 
  isWeb, 
  showAllOptions, 
  large, 
  noDescription, 
  noSpacing, 
  onKeyDown 
}) => {
  const [checked, setChecked] = React.useState({ none: true, ml: false, web: false });

  const onCheckboxClick = (id) => {
    setChecked({ ...{ none: false, ml: false, web: false }, [id]: !checked[id] });
  };

  const inputType = showAllOptions ? 'radio' : 'checkbox';

  return (
    <div
      className={`${styles['container']} ${large ? styles['large'] : ''} ${
        noSpacing ? styles['no-spacing'] : ''
      }`}
    >
      {!noDescription && (
        <p className={styles['description']}>
          <b>Subscribe to get new posts by email!</b>
        </p>
      )}
      <form
        action="https://sendy.leonnoel.com/subscribe"
        method="post"
        acceptCharset="utf-8"
        target="_blank"
      >
        <input type="hidden" name="Source" value={signupSource} />
        <input type="hidden" name="list" value="CWC7638hEb6mfk1RqUbJ763snA" />
        <input
          type="text"
          name="hp"
          style={{ display: 'none' }}
          tabIndex="-1"
          autoCapitalize="off"
          autoCorrect="off"
        />
        <input
          type="email"
          autoCapitalize="off"
          autoCorrect="off"
          name="email"
          size="25"
          placeholder="example@domain.com"
          aria-label="Email Address"
          onKeyDown={onKeyDown}
          style={noDescription ? { marginTop: 0 } : undefined}
        />
        <br />
        {showAllOptions && (
          <label>
            <input
              type={inputType}
              name="Restrictions"
              value=""
              checked={checked.none}
              onChange={onCheckboxClick.bind(null, 'none')}
            />
            Send me <i>all</i> posts
          </label>
        )}
        {showAllOptions && <br />}
        {(isML || showAllOptions) && (
          <label>
            <input
              type={inputType}
              name="Restrictions"
              value={checked.ml ? 'ML' : ''}
              checked={checked.ml}
              onChange={onCheckboxClick.bind(null, 'ml')}
            />
            Send me <i>only</i> ML posts
          </label>
        )}
        {showAllOptions && <br />}
        {(isWeb || showAllOptions) && (
          <label>
            <input
              type={inputType}
              name="Restrictions"
              value={checked.web ? 'Web' : ''}
              checked={checked.web}
              onChange={onCheckboxClick.bind(null, 'web')}
            />
            Send me <i>only</i> Web Dev posts
          </label>
        )}
        {(isML || isWeb || showAllOptions) && <br />}
        <input type="submit" value="SUBMIT" />
      </form>
    </div>
  );
};

export default SubscribeForm;
